import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=2ab90797&scoped=true&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"
import style0 from "./Modal.vue?vue&type=style&index=0&id=2ab90797&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab90797",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ab90797')) {
      api.createRecord('2ab90797', component.options)
    } else {
      api.reload('2ab90797', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=2ab90797&scoped=true&", function () {
      api.rerender('2ab90797', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Sticker/Modal.vue"
export default component.exports